import { commonEnvVariables } from "@/commonEnvVariables";

export const waiverStatusConstants = {
    PENDING: 'Pending',
    REQUESTED: 'Requested',
    APPROVED: 'Approved',
    DENIED: 'Denied',
    CHAPTER_SUBMIT: 'Chapter needs to submit',
    CHAPTER_SUBMIT_NEW: 'Chapter_needs_to_submit',
    NONE: 'None',
};

export const mappedWaiverStatusConstants = {
    PENDING: 'Waiver Pending',
    REQUESTED: 'Waiver Requested',
    APPROVED: 'Waiver Approved',
    DENIED: 'Waiver Denied',
    CHAPTER_SUBMIT: 'Request Waiver',
    NONE: '',
};

export const getManageMyChaptersOptions = (communityId) => {
    const envVariables = commonEnvVariables();
    return [
        {
            id: "chapterManagementHub",
            title: "Chapter Management Hub",
            link: `${window.location.origin}/#/chaptermanagement`,
        },
        {
            id: "chapterManagerCommunications",
            title: "Chapter Manager Comm Hive",
            link: envVariables.CHAPTER_MANAGER_COMMUNICATIONS,
        },
        {
            id: "chapterManagerToolkit",
            title: "Chapter Manager Toolkit",
            link: envVariables.CHAPTER_MANAGEMENT_TOOLKIT,
        },
        {
            id: "chapterWaiversList",
            title: "Chapter Waivers List",
            link: `${envVariables.CHAPTER_WAIVERS}${communityId || ""}`,
        },

    ];
};